import React from 'react';
import "../css/Arrow.css"

const Arrow = ({ direction, onClick, isDisabled }) => {
  return (
    <span
      className={`arrow ${direction}-arrow`}
      onClick={!isDisabled ? onClick : null}
      style={{ color: `${!isDisabled ? "#ddeeff" : "gray"}` }}
    >
      {direction === 'left' ? "◄" : "►"}
    </span>
  )
};

export default Arrow;
